var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "call-slide" } }, [
    _vm.visible
      ? _c(
          "div",
          { staticClass: "incoming-call" },
          [
            _c(
              "el-card",
              { staticClass: "call-card", attrs: { shadow: "always" } },
              [
                _c("div", { staticClass: "call-body" }, [
                  _c("img", {
                    staticClass: "avatar",
                    attrs: {
                      src: require("@/assets/treatment/profile-img.png"),
                      alt: "",
                    },
                  }),
                  _c("div", { staticClass: "info" }, [
                    _c("div", { staticClass: "title" }, [
                      _vm._v("视频通话请求"),
                    ]),
                    _c("div", { staticClass: "patient-name" }, [
                      _vm._v(
                        _vm._s(_vm.callData.patientInfo?.name || "未知患者")
                      ),
                    ]),
                    _c("div", { staticClass: "caller" }, [
                      _vm._v(
                        "来自：" +
                          _vm._s(_vm.callData.callerInfo?.name || "第三方设备")
                      ),
                    ]),
                    _vm.callData.diagRecordCode
                      ? _c("div", { staticClass: "record-code" }, [
                          _vm._v(
                            "诊疗号：" + _vm._s(_vm.callData.diagRecordCode)
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "call-actions" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "danger",
                          size: "small",
                          icon: "el-icon-close",
                        },
                        on: { click: _vm.handleReject },
                      },
                      [_vm._v("拒绝")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "success",
                          size: "small",
                          icon: "el-icon-phone",
                        },
                        on: { click: _vm.handleAccept },
                      },
                      [_vm._v("接听")]
                    ),
                  ],
                  1
                ),
              ]
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }